import { c as _c } from "react/compiler-runtime";
import { ChevronRight } from 'lucide-react';
import { PrV2FilePathLabel } from '../../shared/pr-v2-file-path-label';
import { BetterTooltip } from '@/components/ui/tooltip';
type PrV2FileHeaderRenamedFileLabelProps = {
  filename: string;
  previousFilename: string | null;
};
export function PrV2FileHeaderRenamedFileLabel(t0) {
  const $ = _c(4);
  const {
    filename,
    previousFilename
  } = t0;
  const title = previousFilename ? `${previousFilename} -> ${filename}` : filename;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ChevronRight className="size-3.5 shrink-0 text-zinc-500/70" aria-hidden="true" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== filename || $[2] !== title) {
    t2 = <BetterTooltip content="This file has been renamed but has no content changes to display" side="top"><div className="flex min-w-0 max-w-full items-center gap-2 px-1 py-0.5 text-left">{t1}<PrV2FilePathLabel filename={filename} title={title} basenameClassName="text-[13px] font-medium" directoryClassName="text-[13px]" /></div></BetterTooltip>;
    $[1] = filename;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}